var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('hotel-offers-tariff-popup',{ref:"hotelOffersTariffPopup",attrs:{"tariffs":_vm.tariffs}})
}
var staticRenderFns = []

export { render, staticRenderFns }